import { render, staticRenderFns } from "./ProseBlock.vue?vue&type=template&id=60dbe5f5"
import script from "./ProseBlock.vue?vue&type=script&lang=js"
export * from "./ProseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports